import { render } from "./SirenSearchBarLoading.vue?vue&type=template&id=8524bf8a&scoped=true"
const script = {}

import "./SirenSearchBarLoading.vue?vue&type=style&index=0&id=8524bf8a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8524bf8a"]])

export default __exports__